import { render } from "./Team_manager_adviser_bar_en_m.vue?vue&type=template&id=d892b4e2&scoped=true"
import script from "./Team_manager_adviser_bar_en_m.vue?vue&type=script&lang=js"
export * from "./Team_manager_adviser_bar_en_m.vue?vue&type=script&lang=js"

import "./Team_manager_adviser_bar_en_m.vue?vue&type=style&index=0&id=d892b4e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d892b4e2"

export default script